const FACILITATOR_TOKEN_KEY = 'facilitator_token';

export function saveFacilitatorToken(sessionId: string, token: string): void {
  const key = `${FACILITATOR_TOKEN_KEY}_${sessionId}`;
  localStorage.setItem(key, token);
}

export function getFacilitatorToken(sessionId: string): string | null {
  const key = `${FACILITATOR_TOKEN_KEY}_${sessionId}`;
  return localStorage.getItem(key);
}

export function removeFacilitatorToken(sessionId: string): void {
  const key = `${FACILITATOR_TOKEN_KEY}_${sessionId}`;
  localStorage.removeItem(key);
}


